<div id="top-menu" class="fr" *ngIf="visible()">
  <p-menubar [model]="menu" [autoDisplay]="false"></p-menubar>
  <div class="copy">
    <span>
      &copy; 2018 - 2026 Environmental Instruments Ltd ({{version}})
    </span>
  </div>
</div>
